import {Button} from '@luminopia/react-toolbox/lib/button'
import CheckboxField, { IFieldProps } from 'core/components/form/checkbox-field'
import Form, {ITheme as IFormTheme} from 'core/components/form/Form'
import TextField, {ITextFieldProps, ITheme as ITextFieldTheme} from 'core/components/form/text-field'
import {createValidator, required, integer, email, npiValidator, minLength, match} from 'core/validation'
import * as React from 'react'
import {Field, FormProps, reduxForm, SubmitHandler} from 'redux-form'
import * as classNames from './PasswordChangeForm.css'

export interface IFormFields {
  email: string
  password: string
  confirmPassword: string
  isApproved: boolean
  approvedTime: string
  id: string
}

interface ITheme extends IFormTheme {
  button?: string
  textFieldTheme?: ITextFieldTheme
}

interface IProps extends FormProps<IFormFields, {}, {}> {
  theme?: ITheme
}

/**
 * Approval form intended for use with redux-form.
 */
class PasswordChangeForm extends React.PureComponent<IProps, {}> {
  public render(): React.ReactElement<{}> {

    const { handleSubmit, pristine, submitting, error, theme = {} } = this.props
    const emailProps: ITextFieldProps = {
      label: 'Email',
      placeholder: 'Email',
      onEnter: handleSubmit,
      theme: theme.textFieldTheme,
    }
    const passwordProps: ITextFieldProps = {
      label: 'New Password',
      placeholder: 'New Password',
      onEnter: handleSubmit,
      type: 'password',
      theme: theme.textFieldTheme,
    }
    const confirmPasswordProps: ITextFieldProps = {
      label: 'Confirm New Password',
      placeholder: 'Confirm New Password',
      onEnter: handleSubmit,
      type: 'password',
      theme: theme.textFieldTheme,
    }

    const formTheme: IFormTheme = {
      error: theme.error,
    }

    return (
      <Form onSubmit={handleSubmit} error={error} theme={formTheme}>
        <p>Please note that changing your password below will result in you being logged out to complete the change.</p>
        <Field name='email' component={TextField} type="hidden" props={emailProps}/>
        <Field name='password' component={TextField} props={passwordProps}/>
        <Field name='confirmPassword' component={TextField} props={confirmPasswordProps}/>
        <Button
          className={classNames.button}
          icon='check'
          // label='Reset Password'
          disabled={pristine || submitting}
          raised primary
          onClick={handleSubmit}
        >
        </Button>
      </Form>
    )
  }
}

export default PasswordChangeForm

/**
 * Component factory for creating forms, intended for use with redux-form.
 *
 * @param formName key to where your form's state will be mounted under the redux-form reducer
 * @param onSubmit fn called when prop `handleSubmit` is fired
 */
export const passwordChangeFormFactory = (
  {
    formName,
    onSubmit,
  }: {
    formName: string,
    onSubmit: SubmitHandler<IFormFields, {}, {}>,
  },
) => {
  const initialValues: IFormFields = {
    email: '',
    password: '',
    confirmPassword: '',
    isApproved: true,
    approvedTime: '',
    id: '',
  }

  const validate = createValidator({
    email: [required, email],
    password: [required, minLength(8)],
    confirmPassword: [match<IFormFields>('password', 'Passwords do not match')],
  })

  const formDecorator = reduxForm<IFormFields, {}, {}>({
    form: formName,
    initialValues,
    onSubmit,
    validate,
  })

  return formDecorator(PasswordChangeForm)
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/components/passwordChange/PasswordChangeForm.tsx